module.exports = __webpack_public_path__ + "ic-send-email.svg?d363064ecf36f09ba6e7ac41fb6d6ab5";